import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { CheckoutItem } from 'apps/payment/styles';
import { Heading } from 'components';

@observer
export class DueToday extends React.Component {
  render() {
    const { subscriptionPreview } = this.props;
    if (!subscriptionPreview) return null;
    const total = `${subscriptionPreview.displayFinalAmount}`;

    return (
      <CheckoutItem>
        <Heading level={3}>
          Due today{' '}
          {subscriptionPreview.totalAmount -
            subscriptionPreview.discountAmount ===
          0 ? (
            <span>€0.00</span>
          ) : (
            <span>{total}</span>
          )}
        </Heading>
      </CheckoutItem>
    );
  }
}

DueToday.propTypes = {
  subscriptionPreview: PropTypes.object,
};
